import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import type { StyleProps } from '../types'

const clampLines = (lines: number): CSSObject => ({
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
})

export const text = ({
  lineClamp,
  textColorName,
  theme,
}: StyleProps): CSSObject => ({
  color: textColorName
    ? Color[theme].Text[textColorName]
    : Color[theme].Text.Default,
  ...(lineClamp && { ...clampLines(lineClamp) }),
  ...Typography.T500,
  margin: 0,
  marginBlockEnd: Spacing.M,
})
